export class AppConfigKey {
    static GCL_PRIVATE_ROUTE_AUTH_CODE = 'GCL-Private-Route-Auth-Code'
    static GCL_AZURE_SEARCH_ADMIN_KEY = 'GCL-Azure-Search-Admin-Key'
    static GCL_AZURE_SEARCH_API_KEY = 'GCL-Azure-Search-Api-Key'
    static GCL_GOOGLE_MAPS_API_KEY = 'GCL-Google-Maps-Api-Key'
    static GCL_SES_ROLE_EXT_ID = 'GCL-SES-Role-External-Id'
    static GCL_B4A_API_KEY = 'GCL-B4A-Api-Key'
    static GCL_B4A_JS_KEY = 'GCL-B4A-JS-Key'
}
